import styles from "./../PortfolioDashboard/PortfolioDashboard.module.scss";
import {NavLink, useLocation, useParams} from 'react-router-dom';
// @ts-ignore
import {CSVLink, CSVDownload} from 'react-csv';
// @ts-ignore
import { GreetingsHeader } from '../../components/common/GreetingsHeader';
import * as React from "react";
import Select from "react-select";
import {useState} from "react";
import {IData, IDataarray, IDataBenchmarkColumns, IDataColumns, IDataMetrics} from "../PortfolioDashboard/types";
import {useQuery} from "@apollo/client";
import {ASSESSMENT_RESULTS} from "../../apollo/queries";
import {useLazyQuery} from "@apollo/react-hooks";
import DataTable, {ExpanderComponentProps, TableColumn,} from 'react-data-table-component';
import {customStyles} from "../PortfolioDashboard/customStyles";
import {actualStage,sectors} from "./../PortfolioDashboard/dataFilters";
import downloadImg from "../../styles/download_icon.png";




const columns = [
    {
        name: 'Metric',
        selector: (row: { metric: string; }) => row.metric,
    },
    {
        name: 'Selection',
        selector: (row: { value_selection: string; }) => row.value_selection,
    },
    {
        name: 'Benchmark',
        selector: (row: { value_benchmark: string; }) => row.value_benchmark,
    },
    {
        name: 'Difference',
        selector: (row: { difference: string; }) => row.difference,
    },
];

export const Benchmark = () => {
    const { id } = useParams();

    //collected dataobject from api
    // const [benchmarkDataMetrics, setBenchmarkDataMetrics] = useState<IDataBenchmarkColumns[]>();
    const [benchmarkDataMetrics, setBenchmarkDataMetrics] = useState<IDataBenchmarkColumns[]>([]);
    // select filter out sector selection
    const [selectSector, setSelectSector] = useState<{label:string} | null>(null);
    // select filter out actualStage selection
    const [selectActualStage, setSelectActualStage] = useState<{label:string} | null>(null);
    // select filter in tag suggestions
    const [dataTagSuggestions, setDataTagSuggestions] = useState<[{label:string, value: string|number}] | []>([]);
    // select filter out tag selection
    const [tags, setTags] = useState<{label:string, value: string|number} | null>(null);
    // select filter in assessment suggestions
    const [dataAssessmentsSuggestions, setDataAssessmentsSuggestions] = useState<[{label:string, value: string|number}] | []>([]);
    // select filter out assessment selection
    const [selectObject, setSelectObject] = useState<[{label:string, value: string|number}] | [] | null>([]);
    const [selectClear, setSelectClear] = useState<[{label:string, value: string|number}] | []|null>(null);
    const [toggleFilter, setToggleFilter] = useState(true);
    const [toggleTable, setToggleTable] = useState(true);


    const handleClickFilter = () => {{setToggleFilter(!toggleFilter)}};
    const handleClickTable = () => {{setToggleTable(!toggleTable)}};


    useQuery(ASSESSMENT_RESULTS, {
        variables: {
            assessmentId: null,
            tagId: null,
            sector: null,
            actualStage:null
        },
        onCompleted: (someData) => {
            setDataTagSuggestions(someData.resultDataframe.tagOptionsResults)
            setDataAssessmentsSuggestions(someData.resultDataframe.assessmentsOptionsResults)
            setBenchmarkDataMetrics(someData.resultDataframe.benchmarkDataMetrics)
        },
        fetchPolicy: "no-cache"
    });

    const [getAssessmentResults] = useLazyQuery(ASSESSMENT_RESULTS, {
        onCompleted: (someData) => {
            setBenchmarkDataMetrics(someData.resultDataframe.benchmarkDataMetrics)
        },
        fetchPolicy: "no-cache"
    });

    const conditionalRowStyles = [
        {
            when: (row: { difference: string | string[]; }) => row.difference.includes('-'),
            style: {
                backgroundColor: '',
                color: 'red',

            },
        },
        // You can also pass a callback to style for additional customization
        // {
        //     when: row => row.email.includes('.com'),
        //     style: row => ({
        //         backgroundColor: row.phone.startsWith('9') || row.phone.startsWith('1') ? 'pink' : 'inerit',
        //     }),
        // },
    ];
    return (
        <div className={styles.wrapper}>
            <GreetingsHeader title="Benchmark (Beta)" subtitle=""/>
            <div className={styles.flexGrid}>
                <div className={styles.col}>
                    <div>
                        {toggleFilter ?
                            <ul>
                                <button onClick={handleClickFilter}>
                                    <h2><span style={{fontFamily: "consola",fontSize:30,color:"#007476"}}>&minus;</span><span> &nbsp; Filter</span></h2>
                                </button>
                                <div className={styles.flexGridHalfs}>

                                    <div className={styles.col}>
                                        <h4>Select your label:
                                        </h4>
                                        <br/>
                                        {dataTagSuggestions.length > 0 &&
                                            <>
                                                {/*<h5>Your labels</h5>*/}
                                                <Select options={dataTagSuggestions} closeMenuOnSelect={true} value = {tags}  placeholder='Search and select group of companies by your label...'
                                                        classNamePrefix="select" defaultValue={dataTagSuggestions[0]} onChange={
                                                    // @ts-ignore
                                                    async (e) => {
                                                        setSelectClear(null)
                                                        setSelectSector(null)
                                                        setTags(null)
                                                        setSelectActualStage(null)
                                                        setSelectObject(null)
                                                        setTags(e)
                                                        if (e?.label !== undefined) {
                                                            await getAssessmentResults({
                                                                variables: {
                                                                    assessmentId: null,
                                                                    // @ts-ignore
                                                                    tagId: typeof e.value === 'number' ? e.value : parseInt(e.value),
                                                                    sector: null,
                                                                    actualStage:null
                                                                }
                                                            })
                                                        }
                                                    }
                                                }/>
                                            </>
                                        }
                                        {/*{sectors.length > 0 &&*/}
                                        {/*    <>*/}
                                        {/*        <h5>Sectors</h5>*/}
                                        {/*        <Select options={sectors} closeMenuOnSelect={true} value = {selectSector}  placeholder='Select sector...'*/}
                                        {/*                classNamePrefix="select" defaultValue={sectors[0]} onChange={*/}
                                        {/*            async (e:any) => {*/}
                                        {/*                setSelectClear(null)*/}
                                        {/*                setSelectSector(null)*/}
                                        {/*                setTags(null)*/}
                                        {/*                setSelectActualStage(null)*/}
                                        {/*                setSelectObject(null)*/}
                                        {/*                setSelectSector(e)*/}
                                        {/*                if (e?.label !== undefined) {*/}
                                        {/*                    await getAssessmentResults({*/}
                                        {/*                        variables: {*/}
                                        {/*                            assessmentId: null,*/}
                                        {/*                            tagId:null,*/}
                                        {/*                            sector: e.value,*/}
                                        {/*                            actualStage:null*/}
                                        {/*                        }*/}
                                        {/*                    })*/}
                                        {/*                }*/}
                                        {/*            }*/}
                                        {/*        }/>*/}
                                        {/*    </>*/}
                                        {/*}*/}
                                        {/*{actualStage.length > 0 &&*/}
                                        {/*    <>*/}
                                        {/*        <h5>Actual stage</h5>*/}
                                        {/*        <Select options={actualStage}*/}
                                        {/*                closeMenuOnSelect={true}*/}
                                        {/*                value = {selectActualStage}*/}
                                        {/*                placeholder='Select actual stage...'*/}
                                        {/*                classNamePrefix="select"*/}
                                        {/*                defaultValue={actualStage[0]} onChange={*/}
                                        {/*            async (e:any) => {*/}
                                        {/*                setSelectClear(null)*/}
                                        {/*                setSelectSector(null)*/}
                                        {/*                setTags(null)*/}
                                        {/*                setSelectActualStage(null)*/}
                                        {/*                setSelectObject(null)*/}
                                        {/*                setSelectActualStage(e)*/}
                                        {/*                if (e?.label !== undefined) {*/}
                                        {/*                    await getAssessmentResults({*/}
                                        {/*                        variables: {*/}
                                        {/*                            assessmentId: null,*/}
                                        {/*                            tagId:null,*/}
                                        {/*                            // @ts-ignore*/}
                                        {/*                            sector: null,*/}
                                        {/*                            actualStage:e.value*/}
                                        {/*                        }*/}
                                        {/*                    })*/}
                                        {/*                }*/}
                                        {/*            }*/}
                                        {/*        }/>*/}
                                        {/*    </>*/}
                                        {/*}*/}
                                        {/*{dataAssessmentsSuggestions.length > 0 &&*/}
                                        {/*    <>*/}
                                        {/*        <h5>Company assessments</h5>*/}
                                        {/*        <Select options={dataAssessmentsSuggestions}*/}
                                        {/*                closeMenuOnSelect={true}*/}
                                        {/*            //isMulti*/}
                                        {/*                value = {selectObject}*/}
                                        {/*                placeholder='Search company scan and select as filter...'*/}
                                        {/*                classNamePrefix="select"*/}
                                        {/*                defaultValue={dataAssessmentsSuggestions[0]}*/}
                                        {/*                hideSelectedOptions={false}*/}
                                        {/*                onChange={*/}
                                        {/*                    async (e:any) => {*/}
                                        {/*                        setSelectClear(null)*/}
                                        {/*                        setSelectSector(null)*/}
                                        {/*                        setTags(null)*/}
                                        {/*                        setSelectActualStage(null)*/}
                                        {/*                        setSelectObject(null)*/}
                                        {/*                        setSelectObject(e)*/}
                                        {/*                        if (e?.value !== null) {*/}
                                        {/*                            await getAssessmentResults({*/}
                                        {/*                                variables: {*/}
                                        {/*                                    assessmentId: [e.value],*/}
                                        {/*                                    tagId:null,*/}
                                        {/*                                    sector: null,*/}
                                        {/*                                    actualStage:null*/}
                                        {/*                                }*/}
                                        {/*                            })*/}

                                        {/*                        }*/}

                                        {/*                    }*/}
                                        {/*                }*/}
                                        {/*        />*/}
                                        {/*    </>*/}
                                        {/*}*/}
                                        <button className={styles.buttonClearSearch} onClick={
                                            async (e:any) => {
                                                setSelectSector(null)
                                                setTags(null)
                                                setSelectActualStage(null)
                                                setSelectObject(null)
                                                setSelectClear(e)
                                                if (e?.value !== null) {
                                                    await getAssessmentResults({
                                                        variables: {
                                                            assessmentId: null,
                                                            tagId:null,
                                                            sector: null,
                                                            actualStage:null
                                                        }
                                                    })
                                                }
                                            }
                                        }>
                                            Clear filter
                                        </button>
                                    </div>
                                    <div className={styles.col}>
                                        <h4>Explanation:</h4><br/>
                                        Compares your selection of start-ups to companies in a similar growth stage. <br/><br/>

                                        {/*If you select your labels or a company assessment, the benchmark consists of companies that are in a similar milestone. <br/><br/>*/}
                                        {/*For both the sector and stages filters, the benchmark consists of companies with similar sector or stage.<br/><br/>*/}
                                        {/*A red color is given when the selection is lower than the benchmark.*/}
                                        {/*Benchmark data is constructed from a representative group of companies in the startup ecosystem.*/}

                                    </div>
                                </div>
                            </ul>
                            :
                            <>
                                <button onClick={handleClickFilter}>
                                    <h2><span style={{fontFamily: "consola",fontSize:30,color:"#007476"}}>+</span><span> &nbsp; Filter</span></h2>
                                </button>
                            </>
                        }
                    </div>
                </div>
            </div>
            <div className={styles.flexGrid}>
                <div className={styles.col}>
                    <div>
                        {toggleTable ?
                            <ul>
                                <button onClick={handleClickTable}>
                                    <h2><span style={{fontFamily: "consola",fontSize:30,color:"#007476"}}>&minus;</span><span> &nbsp; Benchmark table</span></h2>
                                </button>
                                {benchmarkDataMetrics &&
                                    <CSVLink data={benchmarkDataMetrics} filename="Gritd_CSV_Export_DataMetrics">
                                        <button className={styles.button} style={{float: 'right'}}>
                                            <img src={downloadImg} style={{float: 'right'}} width={15}/>
                                        </button>
                                    </CSVLink>
                                }
                                <div className={styles.main}>
                                    <br/>
                                    <DataTable data={benchmarkDataMetrics}
                                               columns={columns}
                                        // @ts-ignore
                                               customStyles={customStyles}
                                               conditionalRowStyles={conditionalRowStyles}
                                               highlightOnHover
                                    ></DataTable>
                                </div>
                            </ul>
                            :
                            <>
                                <button onClick={handleClickTable}>
                                    <h2><span style={{fontFamily: "consola",fontSize:30,color:"#007476"}}>+</span><span> &nbsp; Benchmark table</span></h2>
                                </button>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}